import { connect } from "react-redux";
//
import { getGenderName, getHumanDuration } from "../utils";
import { formatTime } from "../services/date";
import { goToBack, editSearch, hideModal } from "../modules/modal";
import Screen from "../components/Screen";
import { getCity } from "../selectors";
import { steps } from "../config";

// @connect
const mapState = (state) => {
  const { booking, modal } = state;
  const { screen } = modal;

  // No breadcrumbs
  if (screen === "login") {
    return { breadcrumbs: [] };
  }

  const breadcrumbs = [false, "City", "Gender", false, "Time", "Duration"];

  let step = steps.indexOf(screen);

  if (step === -1) {
    // Force further step in order to display ALL crumbs
    step = 6; // --> "After duration"
  }

  const city = getCity(state);

  // After city
  if (step > 1) {
    breadcrumbs.splice(1, 1, city.name);
  }

  // After gender
  if (step > 2) {
    breadcrumbs.splice(2, 1, getGenderName(booking.genderId));
  }

  // After time
  if (step > 4) {
    breadcrumbs.splice(4, 1, formatTime(booking.date, city.timezone));
  }

  // After duration
  if (step > 5) {
    breadcrumbs.splice(5, 1, getHumanDuration(booking.duration));
  }

  if (step === 0) {
    step = 1;
  }

  return { breadcrumbs, step };
};

const mapDispatch = (dispatch, ownProps) => {
  let { onBack, onClose } = ownProps;

  if (onBack === undefined) {
    onBack = function onBack() {
      dispatch(goToBack());
    };
  }

  const methods = {
    onBack,
    editSearch(name) {
      dispatch(editSearch(name));
    },
  };

  if (onClose === false) {
    return methods;
  }

  methods.onClose = function onClose() {
    dispatch(hideModal());
  };

  return methods;
};

export default connect(
  mapState,
  mapDispatch
)(Screen);
